import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { validators } from 'investira.sdk';
import { MaterialReactTable, Stack } from 'investira.react.components';

/**
 * Renderiza o componente DataTable.
 *
 * @param {Object} props - Propriedades do componente.
 * @param {Array} props.data - Propriedade `data` do componente.
 * @param {Array} props.columns - Propriedade `columns` do componente.
 * @param {Object} props.initialState - Propriedade `initialState` do componente.
 *
 * @description
 * Este componente realiza as seguintes operacoes:
 * 1. Recebe as propriedades necessarias para compor a interface
 * 2. Organiza os estados e callbacks usados durante a renderizacao
 * 3. Renderiza a experiencia visual do organismo
 *
 * @returns {JSX.Element|null} Elemento renderizado pelo componente.
 */

const DataTable = memo(props => {
  const {
    columns,
    data = [],
    renderRowActions,
    renderDetailPanel,
    initialState = {},
    ...restProps
  } = props;

  const xProps = {
    columns,
    data,
    initialState: {
      density: 'compact',
      ...initialState
    },
    enableColumnResizing: false,
    enableGlobalFilter: false,
    enableStickyHeader: true,
    enableStickyFooter: true,
    enableColumnFilters: false,
    ...(!validators.isNull(renderRowActions) && {
      enableRowActions: true,
      positionActionsColumn: 'last',
      renderRowActions
    }),
    ...(!validators.isNull(renderDetailPanel) && {
      enableExpandAll: false,
      enableExpanding: true,
      renderDetailPanel: renderDetailPanel
    }),
    enableFullScreenToggle: false,
    memoMode: 'cell',
    muiLinearProgressProps: {
      sx: { height: '4px' }
    },
    muiBottomToolbarProps: {
      sx: {
        mb: 3
      }
    },
    muiTopToolbarProps: {
      sx: { backgroundColor: 'none', alignItems: 'center' }
    },
    muiTableContainerProps: ({ table }) => {
      return {
        sx: {
          height: 'fit-content',
          maxHeight: 'fit-content'
        }
      };
    },
    ...restProps
  };

  return (
    <Stack flexGrow={1}>
      <MaterialReactTable {...xProps} />
    </Stack>
  );
});

DataTable.propTypes = {
  data: PropTypes.array.isRequired,
  columns: PropTypes.array.isRequired,
  initialState: PropTypes.object
};

DataTable.default = {
  pagination: {}
};

export default DataTable;
